import React from "react";
import logo from "./kellanova-logo.svg";
import TeamIcon from "@mui/icons-material/Business";
import ContactsIcon from "@mui/icons-material/Contacts";
import PriorityIcon from "@mui/icons-material/NewReleases";
import InMarketIcon from "@mui/icons-material/Dns";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import FolderSpecialIcons from "@mui/icons-material/FolderSpecial";
import BrokerIcon from "@mui/icons-material/PeopleOutline";
import clientOnlyResources from ".";
import theme from "client/kelloggs/theme";
import svglogo from "client/kelloggs/KellanovaLogo";
import DavFiles from "dav_files";
import retry from 'custom_components/retry'
import { 
  fullFeatureList,
  storeAttrOptions,
  storeGroupByOptions,
  itemAttrOptions,
  storeFilterOptions,
  itemGroupColumnOptions,
  runtimeItemGroupFilterOptions
} from 'client/kelloggs/hardcoded_features'

const AUTH_SUPPLIER_SOURCES = [
  { id: "DST", name: "DST" },
  { id: "KEL", name: "KEL" },
];

// list of dashboard deployment targets used by the
// dashboard deployment to separate targets into tabs
//
// [
//   {
//     id: <name of resource to target>,
//     name: <label displayed as Tab Name>
//   }
// ]
const DEPLOY_TARGET_TABS = [
  { id: "main_dashboard", name: "Main Dashboard" }, // default - main dashboard
  { 
    id: "master_chain", 
    name: "Chains",
    dimension: "kellogg_chain",
    targetConfig: {
      resource_name: "master_chain",
      name: "Chain",
      column_defs: [{ id: 50 }, { primary_name: 350 }],
      filter_column: "kellogg_chain@eq",
    }
  }, // default - chain page
  { 
    id: "account_handler", 
    name: "Handlers",
    featureTag: "account_handler",
    dimension: "account_handler",
    targetConfig: {
      resource_name: "kelloggs_account_handler",
      name: "Handler",
      column_defs: [{ id: 50 }, { name: 350 }],
      filter_column: "account_handler@eq",
    }
  }, // kelloggs custom store categorical
  { 
    id: "account_team", 
    name: "Teams",
    featureTag: "account_team",
    dimension: "account_team",
    targetConfig: {
      resource_name: "kelloggs_account_team",
      name: "Teams",
      column_defs: [{ id: 50 }, { name: 350 }],
      filter_column: "account_team@eq",
    }
  }, // kelloggs custom store attribute
  {
    id: "broker",
    name: "Brokers",
    featureTag: "broker",
    dimension: "broker",
    targetConfig: {
      resource_name: "kelloggs_broker",
      name: "Broker",
      column_defs: [{ id: 50 }, { name: 350 }],
      filter_column: "broker@eq",
    }
  },
  { 
    id: "nacs_region", 
    name: "Regions",
    dimension: "nacs_region",
    targetConfig: {
      resource_name: "kelloggs_region",
      name: "Region",
      column_defs: [{ id: 50 }, { region_name: 350 }],
      filter_column: "nacs_region@eq",
    }
  }, // default - nacs region page
  // { 
  //   id: "priority_level_1", 
  //   name: "Priority Level 1",
  //   featureTag: "priority",
  //   dimension: "priority_level",
  //   targetConfig: {
  //     resource_name: "kelloggs_priority_item_groups",
  //     name: "Priority Level 1",
  //     column_defs: [{ id: 50 }, { name: 350 }],
  //     filter_column: "priority_level_1@eq",
  //   }
  // }, // kelloggs custom item attribute
  { 
    id: "priority_level_2", 
    name: "Priority Level 2",
    featureTag: "priority",
    dimension: "priority_level",
    targetConfig: {
      resource_name: "kelloggs_priority_level",
      name: "Priority Level 2",
      column_defs: [{ id: 50 }, { name: 350 }],
      filter_column: "priority_level_2@eq",
    }
  }, // kelloggs custom item attribute
  { 
    id: "brand_id", 
    name: "Items",
    targetConfig: {
      resource_name: "kelloggs_master_items",
      name: "Items",
      column_defs: [
        { id: 50 },
        { infobate_description: 350 },
        { infobate_measure: 50 },
        { infobate_manufacturer: 350 },
      ],
      filter_column: "brand_id@eq",
    }
  }, 
  {
    id: "in_market_hierarchy",
    name: "Market Hierarchy",
    featureTag: "in_market_hierarchy",
    dimension: "in_market_hierarchy",
    targetConfig: {
      resource_name: "kelloggs_in_market_hierarchy",
      name: "In Market Hierarchy",
      column_defs: [{ id: 50 }, { name: 350 }],
      filter_column: "in_market_hierarchy_level_1@eq",
    }
  },
  {
    id: "in_market_category", 
    name: "Market Categories",
    featureTag: "in_market_category",
    dimension: "in_market_category",
    targetConfig: {
      resource_name: "kelloggs_in_market_category",
      name: "In Market Category",
      column_defs: [{ id: 50 }, { name: 350 }],
      filter_column: "in_market_category@eq",
    }
  },
];



// User roles that are available for this client
//
const userRoles = [
  { id: "kelloggs", name: "Kelloggs" },
  { id: "kelloggs_admin", name: "Kelloggs Admin" },
  { id: "site_admin", name: "Site Admin" },
];

const customRoutes = [
  {
    path: "/files/kelloggs_admin",
    component: DavFiles,
    allowedRoles: ["kelloggs_admin", "site_admin"],
  },
  {
    path: "/files/kelloggs",
    component: DavFiles,
    allowedRoles: ["kelloggs", "kelloggs_admin", "site_admin"],
  },
];



// = {
//   "/files/kelloggs_admin": {
//     allowedRoles: ["kelloggs_admin", "site_admin"],
//   },
//   "/files/kelloggs": {
//     allowedRoles: ["kelloggs", "kelloggs_admin", "site_admin"],
//   },
// };

// Extra menu customization for client specific resources
// This object extends the default menu choices allowing
// side menu links to resources that do not exist for anyone but client
// Submenu placement is determined by config under either menuCustomer, menuItem, and menuFiles keys (Customer, Item, Files respectively).
// Only those three top level menues can be extended currently.
// Permissions can be used to determine menu visibility to a role
// but underlying permissions to the resource will still be enforced on
// the HTTP APIs
const menuCustomization = {
  menuCustomer: [
    {
      // side menu link for Kelloggs Customer Teams
      to: `/kelloggs_account_team`,
      label: "Teams",
      icon: <TeamIcon />,
      featureTag: "account_team"
    },
    {
      // side menu link for Kelloggs Customer Handler
      to: `/kelloggs_account_handler`,
      label: "Handler",
      icon: <ContactsIcon />,
      featureTag: "account_handler"
    },
    {
      // side menu link for Kelloggs Broker
      to: `/kelloggs_broker`,
      label: "Broker",
      icon: <BrokerIcon />,
      featureTag: "broker"
    }
  ],
  menuItem: [
    {
      // side menu link for Kelloggs Priority Items
      to: `/kelloggs_priority_level`,
      label: "Priority Groups",
      icon: <PriorityIcon />,
      featureTag: "priority"
    },
    {
      // side menu link for Kelloggs In Market Category Items
      to: `/kelloggs_in_market_hierarchy`,
      label: "Market Hierarchy",
      icon: <InMarketIcon />,
      featureTag: "in_market_hierarchy"
    },
    {
      // side menu link for Kelloggs In Market Category Items
      to: `/kelloggs_in_market_categories`,
      label: "Market Categories",
      icon: <InMarketIcon />,
      featureTag: "in_market_category"
    }
  ],
  menuFiles: [
    {
      // side menu link for Kelloggs Admin File access
      to: "/files/kelloggs_admin",
      label: "Admin Files",
      icon: <FolderSpecialIcons />,
      allowedRoles: ["kelloggs_admin", "site_admin"],
    },
    {
      // side menu link for Kelloggs File Access
      to: `/files/kelloggs`,
      label: "Files",
      icon: <FolderSharedIcon />,
      allowedRoles: ["kelloggs", "kelloggs_admin", "site_admin"],
    },
  ],
  // 'extraMenu': {}
};


// Client overrides of default pages.
// Used when client has customized attribution and business rules which
// cannot be addressed in the default views (infobate only attribution)
const customPages = {
  master_chain: {
    edit: React.lazy(() =>
      retry(() => import("./master_chain/MasterChainEdit"))
    ),
    list: null,
    // edit: null
  },
  master_customers: {
    // list: null,
    // edit: null
    edit: React.lazy(() =>
      retry(() => import("./master_customers/Edit"))
    ),
    list: React.lazy(() =>
      retry(() => import("./master_customers/List"))
    ),
  },
  master_items: {
    // list: null,
    // edit: null
    edit: React.lazy(() =>
      retry(() => import("./master_items/Edit"))
    ),
    list: React.lazy(() =>
      retry(() => import("./master_items/List"))
    ),
  },
};


const dashboardConfig = {
  sunburstHierarchies: {
    "Distributor/Warehouse": ["distributor_name", "warehouse_name"],
    "Priority Level/Item": ["priority_level", "brand_id"],
    "Priority Level 2/Item": ["priority_level_2", "brand_id"],
    "In Market Category/Item": ["in_market_category", "brand_id"],
    "In Market Category/Sub Category": [
      "in_market_category",
      "in_market_sub_category",
    ],
    "In Market Category/Sub Category/Item": [
      "in_market_category",
      "in_market_sub_category",
      "brand_id",
    ],

    "In Market Hierarchy/Item": ["in_market_hierarchy_level_1", "brand_id"],
    "In Market Hierarchy/Sub Category": [
      "in_market_hierarchy_level_1",
      "in_market_hierarchy_level_2",
    ],  
    "In Market Hierarchy/Level 2/Item": [
      "in_market_hierarchy_level_1",
      "in_market_hierarchy_level_2",
      "brand_id",
    ],
  },
};

const COMPLETE_CONFIG = {
  CLIENT_NAME_LABEL: "Kelloggs",
  CLIENT_NAME: "kelloggs",
  CLIENT_LOGO: logo,
  APP_BAR_LOGO: svglogo,
  AUTH_SUPPLIER_SOURCES: AUTH_SUPPLIER_SOURCES,
  USER_ROLES: userRoles,
  CLIENT_CUSTOM_ROUTES: customRoutes,
  EXTRA_MENUS: menuCustomization,
  CUSTOM_PAGES: customPages,
  DASHBOARD_CONFIG: dashboardConfig,
  DEPLOY_TARGET_TABS: DEPLOY_TARGET_TABS,
  CUSTOM_RESOURCES: clientOnlyResources,
  CLIENT_THEME: theme,
  BACKGROUND_IMAGE: "login1.jpg",
  featureList: fullFeatureList,
  routeOverrides: {
    "master_customer": {
      'POST': {
        'transform': (data) => {
          console.log('transform function called at Master Customer Edit level', {
            ...data,
            kellogg_chain_id: data.kelloggs_chain_id
          });
          return {
            ...data,
            kellogg_chain_id: data.kelloggs_chain_id
          }
        }
      }
    }
  },
  REPORTING_OPTIONS: {
    storeAttrOptions,
    storeGroupByOptions,
    itemAttrOptions,
    storeFilterOptions,
    itemGroupColumnOptions,
    runtimeItemGroupFilterOptions,
    reportAvailability: {
      "Period Comparison": true,
      "Period Comparison Store Level": true,
      "Fact Summary": true,
      "Store Rows/Item Columns Pivot": true,
      "Store Group Rows/Item Columns Pivot": true,
      "Store Rows/Item Columns Pivot (No Item Groups)": true,
      "Item Group Summary": true,
      "ACV by Store Group And Period": true,
      "Void Report": false,
    },
    calendarFormat: "445"
  }
};
export default COMPLETE_CONFIG;
